export default __webpack_public_path__ + "static/media/carousel2headset.339bd45b.png";